import React from 'react';
import { TimeInput } from 'src/components/oneCorp/features/MealCredit/common/formFields/TextInput/TimeInput/TimeInput';

export interface StartTimeInputProps {
  name: string;
  id: string;
  disabled?: boolean;
}

export function StartTimeInput({
  name,
  id,
  disabled = false,
}: StartTimeInputProps): JSX.Element {
  return (
    <TimeInput label="Start time" name={name} id={id} disabled={disabled} />
  );
}
